"use client"

import {  TrendingUp, MapPin, DollarSign } from "lucide-react"
import { Link } from "react-router-dom"
import DashboardLayout from "@/views/dashboard/DashboardLayout"
import { Button } from "@/components/ui/common/Button"

export default function StudentsPage() {
  return (
    <DashboardLayout>
      <div className="p-6">
        <div className="space-y-8">
          <div className="  ">
           
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="p-4 border   bg-blue-50 border-blue-200">
                <div className="flex items-center mb-2">
                  <TrendingUp className="h-5 w-5 text-blue-600 mr-2" />
                  <h3 className="font-medium text-gray-900">Ścieżki kariery</h3>
                </div>
                <p className="text-sm text-gray-600 mb-3">Rekomendacje rozwoju zawodowego</p>
                <Link to="/students/career-paths">
                  <Button variant="outline" size="sm" className="w-full border-gray-200 bg-white border-1">
                    Planuj karierę
                  </Button>
                </Link>
              </div>

              <div className="p-4 border   bg-orange-50 border-orange-200">
                <div className="flex items-center mb-2">
                  <MapPin className="h-5 w-5 text-orange-600 mr-2" />
                  <h3 className="font-medium text-gray-900">Mapa zawodów</h3>
                </div>
                <p className="text-sm text-gray-600 mb-3">Zapotrzebowanie wg regionów</p>
                <Link to="/students/job-map">
                  <Button variant="outline" size="sm" className="w-full border-gray-200 bg-white border-1">
                    Otwórz mapę
                  </Button>
                </Link>
              </div>

              <div className="p-4 border   bg-yellow-50 border-yellow-200">
                <div className="flex items-center mb-2">
                  <DollarSign className="h-5 w-5 text-yellow-600 mr-2" />
                  <h3 className="font-medium text-gray-900">Zarobki</h3>
                </div>
                <p className="text-sm text-gray-600 mb-3">Mediana zarobków na stanowiskach</p>
                <Link to="/students/earnings">
                  <Button variant="outline" size="sm" className="w-full border-gray-200 bg-white border-1">
                    Sprawdź zarobki
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  )
}
